require('./brokerWarrantsAdvancedBuyStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const BuySellConditionTypeDropdown = require('components/broker/commons/buySellConditionTypeDropdown/buySellConditionTypeDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OKMessage } = require('commonsComponents/OKMessage');
const { AmountInput } = require('commonsComponents/amountInput');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');

// @constants
const {
    FIRST_STEP,
    BROKER_CONDITION_OVER_WARRANT_PRICE,
    BROKER_CONDITION_OVER_UNDERLYING_PRICE,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_STOCKS_ADVANCED_BUY_AMOUNT_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_ADVANCED_BUY_PERCENTAGE_FIELDS_MAXLENGHT_LIMIT
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ actions
const BrokerWarrantsAdvancedBuyActions = require('actions/brokerWarrantsAdvancedBuy');

class BrokerWarrantsAdvancedBuyStep1 extends React.Component {

    constructor(props) {
        super(props);
        this.handleConditionTypeValueChanged = this.handleConditionTypeValueChanged.bind(this);
        this.onAmountFieldChange = this.onAmountFieldChange.bind(this);
    }

    onAmountFieldChange(value) {
        this.props.handleConditionTypeValueChanged(value);
    }

    buildAmountField() {
        const { immBrokerWarrantsAdvancedBuy } = this.props;
        const conditionTypeValue = immBrokerWarrantsAdvancedBuy.getIn(['steps', FIRST_STEP, 'conditionTypeValue']);
        const conditionTypeInvalid = immBrokerWarrantsAdvancedBuy.getIn(['steps', FIRST_STEP, 'invalidConditionTypeValue']);
        const conditionTypeErrorMessage = formatText('broker-stocksAdvancedBuyConditionTypeErrorMessage');

        return (
            <div className="warrants-advanced-buy-step1__condition-type-value-input">
                <AmountInput
                    amount={conditionTypeValue}
                    callback={this.onAmountFieldChange}
                    max={BROKER_STOCKS_ADVANCED_BUY_AMOUNT_FIELDS_MAXLENGHT_LIMIT}
                    className="warrants-advanced-buy-step1__condition-type-value-label"
                    errorState={conditionTypeInvalid}
                    errorMessage={conditionTypeErrorMessage}
                    language={language}
                    hideFocusZero
                />
            </div>
        );
    }

    buildConditionTypeValueSection() {
        const { immBrokerWarrantsAdvancedBuy } = this.props;
        const conditionType = immBrokerWarrantsAdvancedBuy.getIn(['steps', FIRST_STEP, 'conditionType']);
        let conditionTypeValueField;
        let conditionTypeValueFieldLabelKey;

        switch (conditionType) {
            case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                conditionTypeValueField = this.buildPercentageField();
                conditionTypeValueFieldLabelKey = 'broker-stocksAdvancedBuyConditionTypePercentageValue';
                break;
            default:
                conditionTypeValueField = this.buildAmountField()
                conditionTypeValueFieldLabelKey = 'broker-stocksAdvancedBuyConditionTypeAmountValue';
                break;
        }

        return (
            <div className="warrants-advanced-buy-step1__condition-type-value-section warrants-advanced-buy-step1__section-subtitle">
                <FormattedText value={conditionTypeValueFieldLabelKey} className="warrants-advanced-buy-step1__condition-type-value-label" />
                {conditionTypeValueField}
            </div>
        );
    }

    buildPercentageField() {
        const { immBrokerWarrantsAdvancedBuy } = this.props;
        const conditionTypeValue = immBrokerWarrantsAdvancedBuy.getIn(['steps', FIRST_STEP, 'conditionTypeValue']);
        const conditionTypeInvalid = immBrokerWarrantsAdvancedBuy.getIn(['steps', FIRST_STEP, 'invalidConditionTypeValue']);
        const conditionTypeErrorMessage = formatText('broker-stocksAdvancedBuyConditionTypeErrorMessage');

        return (
            <div className="warrants-advanced-buy-step1__condition-type-value-input">
                <InputSafe
                    type="text"
                    value={conditionTypeValue}
                    autoComplete="off"
                    onChange={this.handleConditionTypeValueChanged}
                    maxLength={BROKER_STOCKS_ADVANCED_BUY_PERCENTAGE_FIELDS_MAXLENGHT_LIMIT}
                    errorState={conditionTypeInvalid}
                    errorMessage={conditionTypeErrorMessage}
                />
            </div>
        );
    }

    handleConditionTypeValueChanged(event) {
        const filteredValue = nonNumericFilter(event.target.value);
        this.props.handleConditionTypeValueChanged(filteredValue);
    }

    render() {
        const {
            immBrokerWarrantsAdvancedBuy,
            handleOrderTermsChanged,
            handleConditionTypeChanged
        } = this.props;

        const step1 = immBrokerWarrantsAdvancedBuy.getIn(['steps', FIRST_STEP]);
        const orderType = step1.get('orderType');
        const conditionType = step1.get('conditionType');
        const conditionTypeValueSection = this.buildConditionTypeValueSection();
        const validityDate = step1.get('validityDate');

        return (
            <div className="warrants-advanced-buy-step1">
                <header className="warrants-advanced-buy-step1__header">
                    <h2 className="warrants-advanced-buy-step1__header-title">
                        <FormattedText value="broker-warrantsAdvancedBuyHeaderTitle" />
                    </h2>
                </header>
                <section className={"warrants-advanced-buy-step1__group-div"}>
                    <div className="warrants-advanced-buy-step1__subgroup-div">
                        <h4 className="warrants-advanced-buy-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedBuyOrderTypeSubtitle" />
                            <OKTooltip
                                content="broker-todoTooltip"
                                offset={[0, -10]}
                            />
                        </h4>
                        <RadioButtonGroup
                            selectedValue={orderType}
                            onChange={handleOrderTermsChanged}
                            name="orderTermsRadioGroup"
                            idPrefix="orderTermsRadioGroup"
                        >
                            <RadioButton
                                label={formatText('broker-warrantsAdvancedBuyConditionalWarrantPrice')}
                                value={BROKER_CONDITION_OVER_WARRANT_PRICE}
                                className="warrants-advanced-buy-step1__radio-button"
                            />
                            <RadioButton
                                label={formatText('broker-warrantsAdvancedBuyConditionalUnderlyingPrice')}
                                value={BROKER_CONDITION_OVER_UNDERLYING_PRICE}
                                className="warrants-advanced-buy-step1__radio-button"
                            />
                        </RadioButtonGroup>
                    </div>
                </section>
                <div className="warrants-advanced-buy-step1__group-div">
                    <h3 className="warrants-advanced-buy-step1__section-title">
                        <FormattedText value="broker-warrantsAdvancedBuyConditionEventSectionTitle" />
                    </h3>

                    <div className="warrants-advanced-buy-step1__subgroup-div">

                        <div className="warrants-advanced-buy-step1__condition-type-dropdown">
                            <BuySellConditionTypeDropdown
                                onConditionTypeChange={handleConditionTypeChanged}
                                selectedValue={conditionType}
                            />
                        </div>
                        {conditionTypeValueSection}
                    </div>
                    <div className="warrants-advanced-buy-step1__subgroup-div">
                        <h4 className="warrants-advanced-buy-step1__section-subtitle warrants-advanced-buy-step1__clear">
                            <FormattedText value="broker-stocksAdvancedBuyValidityDateSubtitle" />
                            <OKTooltip
                                content="broker-todoTooltip"
                                offset={[0, -10]}
                            />
                        </h4>
                        <DatePickerCustom
                            selectedDate={validityDate}
                            disabled={true}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
                <div className="warrants-advanced-buy-step1__group-div">
                    <OKMessage
                        id="warrants-advanced-buy-step3-disclaimer"
                        type="informative"
                        visible={true}
                        extraClass="warrants-advanced-buy-step1__disclaimer"
                    >
                        <span className="warrants-advanced-buy-step1__disclaimer-block">
                            <FormattedText value="broker-warrantsAdvancedBuyStep1DisclaimerFirstPart" />
                        </span>
                        <span className="warrants-advanced-buy-step1__disclaimer-block">
                            <FormattedText value="broker-warrantsAdvancedBuyStep1DisclaimerSecondPart" />
                        </span>
                    </OKMessage>
                </div>
            </div>
        );
    }
}

BrokerWarrantsAdvancedBuyStep1.propTypes = {
    immBrokerWarrantsAdvancedBuy: PropTypes.object.isRequired,
    handleOrderTermsChanged: PropTypes.func.isRequired,
    handleConditionTypeChanged: PropTypes.func.isRequired,
    handleConditionTypeValueChanged: PropTypes.func.isRequired
};

module.exports.constructor = BrokerWarrantsAdvancedBuyStep1;

module.exports.BrokerWarrantsAdvancedBuyStep1 = connect(state => ({
    immBrokerWarrantsAdvancedBuy: state.brokerWarrantsAdvancedBuy
}), {
        handleOrderTermsChanged: BrokerWarrantsAdvancedBuyActions.orderTermsChanged,
        handleConditionTypeChanged: BrokerWarrantsAdvancedBuyActions.conditionTypeChanged,
        handleConditionTypeValueChanged: BrokerWarrantsAdvancedBuyActions.conditionTypeValueChanged
    })(BrokerWarrantsAdvancedBuyStep1);
